<div class="floating-chat" [class.open]="isOpen" *ngIf="isAuthenticated && canShowChat">
    <!-- Botón flotante para abrir/cerrar -->
    <button
        class="floating-chat__toggle"
        (click)="toggleChat()"
        [attr.aria-expanded]="isOpen"
        [attr.aria-label]="'chat.open-aria' | translate"
    >
        <!-- Ícono del Chat Bot (cerrado) -->
        <img
            src="assets/icon/chat-bot.svg"
            alt="Chat bot icon"
            class="floating-chat__icon"
            *ngIf="!isOpen"
        />
        <!-- Ícono de Cerrar (X) -->
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
            *ngIf="isOpen"
        >
            <line x1="18" y1="6" x2="6" y2="18"></line>
            <line x1="6" y1="6" x2="18" y2="18"></line>
        </svg>
    </button>

    <!-- Panel del chat -->
    <div class="floating-chat__panel" [class.open]="isOpen">
        <!-- Header -->
        <div class="floating-chat__header">
            <h3 class="floating-chat__title">{{ 'chat.title' | translate }}</h3>
            <button
                class="floating-chat__close-btn"
                (click)="closeChat()"
                [attr.aria-label]="'chat.close-aria' | translate"
            >
                ✕
            </button>
        </div>

        <!-- Contenido: Dos botones iniciales o contenido de pestañas -->
        <div class="floating-chat__content">
            <!-- Vista inicial con dos botones -->
            <div class="floating-chat__menu" *ngIf="!isLearning && !isSupport && !isTutor">
                <!-- Botón 1: Aprender (solo visible para rol "aprender") -->
                <button
                    class="floating-chat__menu-btn floating-chat__menu-btn--learning"
                    *ngIf="canShowLearning"
                    (click)="activateLearning()"
                    aria-label="¿Qué deseas aprender hoy?"
                >
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    >
                        <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"></path>
                        <path
                            d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"
                        ></path>
                    </svg>
                    <div class="floating-chat__menu-text">
                        <div class="floating-chat__menu-title">{{ 'chat.menu.learn.title' | translate }}</div>
                        <div class="floating-chat__menu-subtitle">
                            {{ 'chat.menu.learn.subtitle' | translate }}
                        </div>
                    </div>
                </button>

                <!-- Botón 2: Tutor de contenido (solo cuando hay contexto activo) -->
                <button
                    class="floating-chat__menu-btn floating-chat__menu-btn--tutor"
                    *ngIf="canShowTutor"
                    (click)="activateTutor()"
                    [attr.aria-label]="'chat.menu.tutor.aria' | translate"
                >
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    >
                        <circle cx="12" cy="12" r="10"></circle>
                        <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"></path>
                        <line x1="12" y1="17" x2="12.01" y2="17"></line>
                    </svg>
                    <div class="floating-chat__menu-text">
                        <div class="floating-chat__menu-title">{{ 'chat.menu.tutor.title' | translate }}</div>
                        <div class="floating-chat__menu-subtitle">
                            {{ 'chat.menu.tutor.subtitle' | translate }}
                        </div>
                    </div>
                </button>

                <!-- Botón 3: Ayuda (visible para todos) -->
                <button
                    class="floating-chat__menu-btn floating-chat__menu-btn--support"
                    *ngIf="canShowSupport"
                    (click)="activateSupport()"
                    aria-label="Obtener ayuda"
                >
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                    >
                        <circle cx="12" cy="12" r="10"></circle>
                        <path d="M12 16v-4"></path>
                        <path d="M12 8h.01"></path>
                    </svg>
                    <div class="floating-chat__menu-text">
                        <div class="floating-chat__menu-title">{{ 'chat.menu.help.title' | translate }}</div>
                        <div class="floating-chat__menu-subtitle">
                            {{ 'chat.menu.help.subtitle' | translate }}
                        </div>
                    </div>
                </button>
            </div>

            <!-- Wrapper para mensajes y componentes sub -->
            <div class="floating-chat__body" *ngIf="isLearning || isSupport || isTutor">
                <!-- Componente de aprendizaje -->
                <app-learning-assistant
                    *ngIf="isLearning"
                    [messages]="chatMessages"
                    (messageAdded)="onLearningMessage($event)"
                    (courseSelected)="onCourseSelected($event)"
                ></app-learning-assistant>

                <!-- Componente de soporte -->
                <app-support-widget
                    *ngIf="isSupport"
                    [messages]="chatMessages"
                    (messageAdded)="onSupportMessage($event)"
                ></app-support-widget>

                <!-- Componente tutor -->
                <app-tutor-assistant
                    *ngIf="isTutor && tutorContext"
                    [context]="tutorContext"
                    [messages]="tutorMessages"
                    (messageAdded)="onTutorMessage($event)"
                ></app-tutor-assistant>
            </div>
        </div>

        <!-- Footer con acciones -->
        <div class="floating-chat__footer" *ngIf="isLearning || isSupport || isTutor">
            <button
                class="floating-chat__footer-btn floating-chat__footer-btn--back"
                (click)="
                    isLearning = false; isSupport = false; isTutor = false; chatMessages = []; isCourseDetailVisible = false
                "
                aria-label="Volver al menú principal"
            >
                {{ 'chat.back' | translate }}
            </button>
            <button
                class="floating-chat__footer-btn floating-chat__footer-btn--clear"
                (click)="clearChat()"
                aria-label="Limpiar historial"
                title="Limpiar historial del chat"
            >
                🗑️
            </button>
        </div>
    </div>

    <!-- Modal de confirmación para limpiar historial -->
    <div class="floating-chat__modal-overlay" *ngIf="showClearModal" (click)="cancelClearChat()">
        <div class="floating-chat__modal" (click)="$event.stopPropagation()">
            <div class="floating-chat__modal-header">
                <h3>{{ 'chat.clear-history.title' | translate }}</h3>
                <button class="floating-chat__modal-close" (click)="cancelClearChat()" aria-label="Cerrar modal">
                    ✕
                </button>
            </div>
            <div class="floating-chat__modal-body">
                <svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="warning-icon">
                    <circle cx="12" cy="12" r="10"></circle>
                    <line x1="12" y1="8" x2="12" y2="12"></line>
                    <line x1="12" y1="16" x2="12.01" y2="16"></line>
                </svg>
                <p>{{ 'chat.clear-history.confirm' | translate }}</p>
                <p class="warning-text">{{ 'chat.clear-history.warning' | translate }}</p>
            </div>
            <div class="floating-chat__modal-footer">
                <button class="floating-chat__modal-btn floating-chat__modal-btn--cancel" (click)="cancelClearChat()">
                    {{ 'chat.clear-history.cancel' | translate }}
                </button>
                <button class="floating-chat__modal-btn floating-chat__modal-btn--confirm" (click)="confirmClearChat()">
                    {{ 'chat.clear-history.confirm-btn' | translate }}
                </button>
            </div>
        </div>
    </div>
</div>
